var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('a',{on:{"click":_vm.handleClick}},[_c('span',{staticClass:"material-icons",style:({ color: _vm.color, fontSize: _vm.fontSize })},[_vm._v(_vm._s(_vm.name))])]):_c('div',[_c('span',{staticClass:"material-icons",style:({ color: _vm.color, fontSize: _vm.fontSize })},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }